import script from "./purchasedCityList.vue?vue&type=script&setup=true&lang=js"
export * from "./purchasedCityList.vue?vue&type=script&setup=true&lang=js"

import "./purchasedCityList.vue?vue&type=style&index=0&id=55e6cfc2&scoped=true&lang=css"

import exportComponent from "D:\\workspaceJava\\wlyc\\wlyc\\tianjing-client-web-develop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55e6cfc2"]])

export default __exports__